import { styled } from '@mui/material';
import React, { useState, cloneElement, ReactElement, ReactNode, Children } from 'react';
import { ExpandableContainerProps } from './ExpandableContainer';

interface ExpandableListProps {
  children: ReactNode;
}

export const ExpandableList: React.FC<ExpandableListProps> = ({ children }) => {
  const childArray = Children.toArray(children) as ReactElement<ExpandableContainerProps>[];
  const [expandedStates, setExpandedStates] = useState<boolean[]>(
    () => Array(childArray.length).fill(false) as boolean[]
  );

  const handleToggle = (index: number, value: boolean) => {
    setExpandedStates((prev) => prev.map((_, i) => (i === index ? value : false)));
  };

  return (
    <StyledList>
      {childArray.map((child, index) =>
        cloneElement(child, {
          index,
          expanded: expandedStates[index],
          onToggle: handleToggle,
          key: child.key ?? index,
        })
      )}
    </StyledList>
  );
};

const StyledList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;
